import { createRouter, createWebHistory } from 'vue-router';

const LoginView = () => import('@/views/login.vue');
const SSOLogoutView = () => import('@/views/sso-logout.vue');
const AccessDeniedView = () => import('@/views/access-denied.vue');
const RegisterView = () => import('@/views/register.vue');
const PasswordResetView = () => import('@/views/password-reset.vue');
const PasswordChangeView = () => import('@/views/password-change.vue');
const SponsorPendingView = () => import('@/views/sponsor-pending.vue');
const SponsorRejectedView = () => import('@/views/sponsor-rejected.vue');
const SponsorChangeView = () => import('@/views/sponsor-change.vue');
const SponsorResponseView = () => import('@/views/sponsor-response.vue');
const LinkExpiredView = () => import('@/views/link-expired.vue');

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'login' },
    },
    {
      path: '/login/:locale?',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/sso-logout',
      name: 'sso-logout',
      component: SSOLogoutView,
    },
    {
      path: '/access-denied',
      name: 'access-denied',
      component: AccessDeniedView,
    },
    {
      path: '/register/:locale?',
      name: 'register',
      component: RegisterView,
    },
    {
      path: '/password-reset/:locale?',
      name: 'password-reset',
      component: PasswordResetView,
    },
    {
      path: '/password-change/:locale?',
      name: 'password-change',
      component: PasswordChangeView,
    },
    {
      path: '/pending',
      name: 'sponsor-pending',
      component: SponsorPendingView,
    },
    {
      path: '/rejected',
      alias: ['/denied'],
      name: 'sponsor-rejected',
      component: SponsorRejectedView,
    },
    {
      path: '/sponsor-change',
      name: 'sponsor-change',
      component: SponsorChangeView,
    },
    {
      path: '/sponsor-response',
      name: 'sponsor-response',
      component: SponsorResponseView,
    },
    {
      path: '/link-expired',
      name: 'link-expired',
      component: LinkExpiredView,
    },
  ],
});

export default router;
